const VoucherRequestActionType = {
  APPROVE: 1,
  CANCEL: 2,
  DELETE: 3,
  STOP: 4
}
export default VoucherRequestActionType
